type ModalOverlayOptions = {
    disableOverlayBlur?: boolean
    shouldCloseOnOverlayClick?: boolean
}

export function shouldCloseModalOnOverlayClick(modalParams?: ModalOverlayOptions | null): boolean {
    if (typeof modalParams?.shouldCloseOnOverlayClick === 'boolean') {
        return modalParams.shouldCloseOnOverlayClick
    }

    return modalParams?.disableOverlayBlur !== true
}
